import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/categories';
import { IMAGES } from '@/data/images';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.finalCta} alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/90" />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-4 md:px-6 text-center">
        <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
          {t('home.cta.title')}
        </h2>
        <p className="mt-4 text-foreground-700 leading-relaxed">{t('home.cta.body')}</p>
        <a
          href={MAIN_SITE_URL}
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {t('home.cta.button')}
          <i className="ri-arrow-right-line" />
        </a>
        <p className="mt-6 text-xs text-foreground-500 max-w-2xl mx-auto leading-relaxed">
          {t('home.disclaimer')}
        </p>
      </div>
    </section>
  );
}